export const SVG_STYLES = {
  group: {
    stroke: "var(--primary-light)",
    strokeWidth: 1,
    strokeOpacity: 0.7,
    fill: "var(--light-background)",
  },
  hoverGroup: {
    strokeWidth: 1,
    strokeOpacity: 0,
  },
  visibleRegion: {
    stroke: "var(--primary-main)",
    strokeWidth: 1,
    fill: "var(--primary-light)",
    fillOpacity: 0.2,
    pointerEvents: "none",
  },
  anchorPoint: {
    fill: "var(--secondary-light)",
    width: 2,
  },
} as const;

export const REGION_INDICATOR_OVERLAP = 10;
export const MIN_VISIBLE_AREA_WIDTH = 6;
export const MIN_TRACKGROUP_WIDTH = 3;
